/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface CompanyLoginDTO
 */
export interface CompanyLoginDTO {
	/**
	 *
	 * @type {string}
	 * @memberof CompanyLoginDTO
	 */
	email: string;
	/**
	 *
	 * @type {string}
	 * @memberof CompanyLoginDTO
	 */
	password: string;
}

export function CompanyLoginDTOFromJSON(json: any): CompanyLoginDTO {
	return CompanyLoginDTOFromJSONTyped(json, false);
}

export function CompanyLoginDTOFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): CompanyLoginDTO {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		email: json["email"],
		password: json["password"],
	};
}

export function CompanyLoginDTOToJSON(value?: CompanyLoginDTO | null): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		email: value.email,
		password: value.password,
	};
}
